<template>
  <vx-card title="Overtime Type">
    <div id="user-edit-tab-info">
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="vx-col w-full mb-base">
            <template>
              <vs-table
                stripe
                max-items="8"
                pagination
                search
                :data="getOvertimeType"
              >
                <template slot="thead">
                  <vs-th>Id</vs-th>
                  <vs-th>Code</vs-th>
                  <vs-th>Description</vs-th>
                  <vs-th>OT Rate</vs-th>
                  <!-- removed NSD Rate column as per payroll's request. Can be added back later if needed.
                  <vs-th>NSD Rate</vs-th> -->
                  <vs-th>Action</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr
                    :data="tr"
                    :key="indextr"
                    v-for="(tr, indextr) in data"
                  >
                    <vs-td :data="data[indextr].overtimeTypeId">
                      {{ data[indextr].overtimeTypeId }}
                    </vs-td>
                    <vs-td :data="data[indextr].overtimeTypeCode">
                      {{ data[indextr].overtimeTypeCode }}
                    </vs-td>
                    <vs-td :data="data[indextr].overtimeTypeName">
                      {{ data[indextr].overtimeTypeName }}
                    </vs-td>
                    <vs-td :data="data[indextr].otRate">
                      {{ data[indextr].otRate }}
                    </vs-td>
                    <!-- removed NSD Rate column as per payroll's request. Can be added back later if needed.
                    <vs-td :data="data[indextr].nsdRate">
                      {{ data[indextr].nsdRate }}
                    </vs-td>
                    -->
                    <vs-td>
                      <div :style="{ direction: $vs.rtl ? 'rtl' : 'ltr' }">
                        <feather-icon
                          icon="Edit3Icon"
                          svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                          @click="editRecord(data[indextr].overtimeTypeId)"
                        />
                        <feather-icon
                          icon="Trash2Icon"
                          svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
                          @click="
                            confirmDeleteRecord(data[indextr].overtimeTypeId)
                          "
                        />
                      </div>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </template>
          </div>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-button
            type="gradient"
            color="primary"
            @click="promptAddNewRecord()"
            icon-pack="feather"
            icon="icon-plus"
            >Add</vs-button
          >
        </div>
      </div>
      <!-- ADD OT TYPE -->
      <vs-prompt
        class="email-compose"
        title="Add Type of Overtime Type"
        accept-text="Submit"
        @accept="onAddNewRecord"
        :is-valid="validForm"
        :active.sync="activePromptAddRecord"
      >
        <vx-card title="Please fill-out the following information">
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Code</span>
              <span style="color: red">*</span>
              <vs-input
                name="code"
                v-validate="'required'"
                class="w-full"
                v-model="overtimeTypes.overtimeTypeCode"
              />
              <span class="text-danger text-sm" v-show="errors.has('code')">{{
                errors.first("code")
              }}</span>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Description</span
              ><span style="color: red">*</span>
              <vs-input
                name="name"
                v-validate="'required'"
                class="w-full"
                v-model="overtimeTypes.overtimeTypeName"
              />
              <span class="text-danger text-sm" v-show="errors.has('name')">{{
                errors.first("name")
              }}</span>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Ot Rate</span
              ><span style="color: red">*</span>
              <vs-input
                name="Ot Rate"
                v-validate="'required'"
                class="w-full"
                v-model="overtimeTypes.otRate"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('Ot Rate')"
                >{{ errors.first("Ot Rate") }}</span
              >
            </div>
          </div>
          <!-- removed NSD Rate input as per payroll's request. Can be added back later if needed.
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">NSD Rate</span
              ><span style="color: red">*</span>
              <vs-input
                name="NSD Rate"
                v-validate="'required'"
                class="w-full"
                v-model="overtimeTypes.nsdRate"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('NSD Rate')"
                >{{ errors.first("NSD Rate") }}</span
              >
            </div>
          </div> -->
        </vx-card>
      </vs-prompt>
      <!-- END ADD OT TYPE -->

      <!-- EDIT OVERTIME TYPE -->
      <vs-prompt
        class="email-compose"
        title="Edit Overtime Type"
        accept-text="Submit"
        @accept="onUpdateRecord"
        :is-valid="validForm"
        :active.sync="activePromptEditRecord"
      >
        <vx-card title="You may update the following information">
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Code</span>
              <span style="color: red">*</span>
              <vs-input
                name="code"
                v-validate="'required'"
                class="w-full"
                v-model="overtimeTypes.overtimeTypeCode"
              />
              <span class="text-danger text-sm" v-show="errors.has('code')">{{
                errors.first("code")
              }}</span>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Description</span
              ><span style="color: red">*</span>
              <vs-input
                name="name"
                v-validate="'required'"
                class="w-full"
                v-model="overtimeTypes.overtimeTypeName"
              />
              <span class="text-danger text-sm" v-show="errors.has('name')">{{
                errors.first("name")
              }}</span>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Ot Rate</span
              ><span style="color: red">*</span>
              <vs-input
                name="Ot Rate"
                v-validate="'required'"
                class="w-full"
                v-model="overtimeTypes.otRate"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('Ot Rate')"
                >{{ errors.first("Ot Rate") }}</span
              >
            </div>
          </div>
          <!-- removed NSD Rate input as per payroll's request. Can be added back later if needed.
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">NSD Rate</span
              ><span style="color: red">*</span>
              <vs-input
                name="NSD Rate"
                v-validate="'required'"
                class="w-full"
                v-model="overtimeTypes.nsdRate"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('NSD Rate')"
                >{{ errors.first("NSD Rate") }}</span
              >
            </div>
          </div> -->
        </vx-card>
      </vs-prompt>
      <!-- END EDIT OVERTIME TYPE  -->
    </div>
  </vx-card>
</template>
<script>
export default {
  data() {
    return {
      overtimeTypes: {
        overtimeTypeId: 0,
        overtimeTypeCode: "",
        overtimeTypeName: "",
        otRate: 0,
        nsdRate: 0,
      },
      activePromptAddRecord: false,
      activePromptEditRecord: false,
    };
  },
  created() {
    this.$store.dispatch("lookup/getAllOvertimeType").catch((err) => {
      console.log(err);
    });
  },
  computed: {
    getOvertimeType() {
      return this.$store.state.lookup.overtimeTypes;
    },
    validForm() {},
  },
  methods: {
    promptAddNewRecord() {
      this.activePromptAddRecord = true;
    },
    onAddNewRecord() {
      this.$vs.loading();
      this.$store
        .dispatch("lookup/addOvertimeType", this.overtimeTypes)
        .then((response) => {
          this.$vs.loading.close();
          if (response.status == 200)
            this.$alert("", "Save Successfully", "success");
        })
        .catch((error) => {
          this.$vs.loading.close();
          this.$alert(error, "Error", "error");
        });
    },
    editRecord(id) {
      const e = this.$store.getters["lookup/overtimeType"](id);

      (this.overtimeTypes.overtimeTypeId = id),
        (this.overtimeTypes.overtimeTypeCode = e.overtimeTypeCode),
        (this.overtimeTypes.overtimeTypeName = e.overtimeTypeName),
        (this.overtimeTypes.otRate = e.otRate),
        (this.overtimeTypes.nsdRate = e.nsdRate),
        (this.activePromptEditRecord = true);
    },
    onUpdateRecord() {
      this.$vs.loading();
      this.$store
        .dispatch("lookup/updateOvertimeType", this.overtimeTypes)
        .then((response) => {
          this.$vs.loading.close();
          if (response.status == 200)
            this.$alert("", "Updated Successfully", "success");
        })
        .catch((error) => {
          this.$vs.loading.close();
          this.$alert(error, "Error", "error");
        });
    },
  },
};
</script>
